// extracted by mini-css-extract-plugin
var _1 = "C76IK";
var _2 = "IDxGB";
export { _1 as "downloadButtonIcon", _2 as "downloadButtonsWrapper" }
